module.exports = __webpack_public_path__ + "media/images/icon-search-7ab16c983f326505b4a37991937306ae.svg";